import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Radio } from "lucide-react";
import { usePoll } from "@/hooks/usePoll";
import { api } from "@/lib/api";
import { Logo } from "@/components/brand/Logo";

// "Founders are LIVE" strip shown on For You / Market while the official broadcast is on air.
export function FoundersLiveBanner({ className = "" }) {
  const navigate = useNavigate();
  const [live, setLive] = useState(null);
  usePoll(async () => { try { setLive((await api.liveStatus()).live); } catch {} }, 30000, []);
  if (!live) return null;
  return (
    <button onClick={() => navigate("/live/founders")} data-testid="founders-live-banner"
      className={`mx-auto mb-3 flex w-full max-w-[600px] items-center gap-3 rounded-2xl border border-aura-gold/40 bg-am-surface px-4 py-2.5 text-left shadow-[0_0_30px_-10px_rgba(255,210,60,0.5)] transition-transform hover:scale-[1.01] ${className}`}>
      <span className="relative grid h-9 w-9 shrink-0 place-items-center rounded-full aura-gradient"><Radio className="h-4 w-4 text-black" /><span className="absolute -right-0.5 -top-0.5 h-3 w-3 animate-ping rounded-full bg-red-500" /><span className="absolute -right-0.5 -top-0.5 h-3 w-3 rounded-full bg-red-500" /></span>
      <span className="min-w-0 flex-1">
        <span className="flex items-center gap-2 text-sm font-bold text-white">Founders are LIVE <span className="rounded-full bg-red-500 px-1.5 py-0.5 text-[10px] font-black uppercase text-white">Live</span></span>
        <span className="block truncate text-xs text-am-text2">{live.title}</span>
      </span>
      <span className="hidden sm:block"><Logo size={22} /></span>
    </button>
  );
}
